import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./utils/firebase";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { useUserStore } from "@/stores/user";
// import { CapacitorShareTarget } from "@capgo/capacitor-share-target";

import { IonicVue } from "@ionic/vue";

import * as Sentry from "@sentry/vue";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* @import '@ionic/vue/css/palettes/dark.class.css'; */

// 1. Dark Mode - Always On
// import "@ionic/vue/css/palettes/dark.always.css";
// document.documentElement.classList.toggle("dark", true);

// 2. Dark Mode - Dynamic based on system settings
import "@ionic/vue/css/palettes/dark.system.css";
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
const toggleDarkPalette = (shouldAdd) => {
  document.documentElement.classList.toggle("dark", shouldAdd);
};
toggleDarkPalette(prefersDark.matches);
prefersDark.addEventListener("change", (mediaQuery) =>
  toggleDarkPalette(mediaQuery.matches),
);

/* Theme variables */
import "./theme/variables.css";
import "./theme/style.css";
import { useAppStore } from "./stores/app";
// import { useRegisterSW } from "virtual:pwa-register/vue";

// const intervalMS = 60 * 60 * 1000;
// const updateServiceWorker = useRegisterSW({
//   onRegistered(r) {
//     r &&
//       setInterval(() => {
//         r.update();
//       }, intervalMS);
//   },
// });

import { defineCustomElements } from "@ionic/pwa-elements/loader";
defineCustomElements(window);

const pinia = createPinia();
const app = createApp(App).use(IonicVue).use(router).use(pinia);
app.config.globalProperties.$log = console.log;

Sentry.init({
  app,
  dsn: "https://f79e3e1f05c6763284a0cd0d4e92cc53@o4511021034045440.ingest.de.sentry.io/4511021046431824",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

// const userStore = useUserStore();
// const auth = getAuth();
// onAuthStateChanged(auth, (user) => {
//   if (user) {
//     // User is signed in, see docs for a list of available properties
//     // https://firebase.google.com/docs/reference/js/auth.user
//     // const uid = user.uid;
//     // ...
//     console.log(user.uid);
//     userStore.user = user;
//   } else {
//     // User is signed out
//     // ...
//   }
//   userStore.isUserLoading = false;
// });

const appStore = useAppStore();
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevents the default mini-infobar or install dialog from appearing on mobile
  e.preventDefault();
  // Save the event because you'll need to trigger it later.
  appStore.deferredPrompt = e;
  // Show your customized install prompt for your PWA
  // Your own UI doesn't have to be a single element, you
  // can have buttons in different locations, or wait to prompt
  // as part of a critical journey.
  // showInAppInstallPromotion();
  console.log("beforeinstallprompt");
});
window.addEventListener("appinstalled", () => {
  appStore.isAppInstalled = true;
  // If visible, hide the install promotion
  // hideInAppInstallPromotion();
  // Log install to analytics
  console.log("INSTALL: Success");
});

// Listen for shared content
// CapacitorShareTarget.addListener("shareReceived", (event) => {
//   alert("Shared content received!", JSON.stringify(event));
//   console.log("Title:", event.title);
//   console.log("Texts:", event.texts);

//   event.files?.forEach((file) => {
//     console.log(`File: ${file.name}`);
//     console.log(`Type: ${file.mimeType}`);
//     console.log(`URI: ${file.uri}`);
//   });
// });

router.isReady().then(() => {
  app.mount("#app");
});
